import React, { useContext } from 'react';
import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';
import { AppContext } from '@prisjakt/ui-app-context';
import { FontEmphasis } from '@prisjakt/ui/text';
import { IconDelivery } from '@prisjakt/ui/icon';
import { ShippingCollection, StockStatus } from 'src/types';
import { Tooltip, TooltipPlacement } from 'src/components/tooltip-new';
import {
  ShippingType,
  getDeliveryDaysText,
  getStandardizedDeliveryText,
} from './utils';
import { Wrapper, MediumUp, IconWrapper, CaptionText } from './styles';

interface IDeliveryTimeProps {
  shipping?: ShippingCollection | null;
  stockStatus?: StockStatus | null;
}

export const DeliveryTime: React.FC<IDeliveryTimeProps> = props => {
  const { shipping, stockStatus } = props;
  const { t } = useContext(AppContext);
  const deliveryDaysText = getDeliveryDaysText(
    t,
    ShippingType.CHEAPEST,
    shipping
  );
  const standardizedDeliveryText = getStandardizedDeliveryText(t, stockStatus);
  const tooltipLabel = t('product', 'delivery-time.label');
  const deliveryTimeText = deliveryDaysText ?? standardizedDeliveryText;

  if (!deliveryDaysText && !standardizedDeliveryText) {
    return null;
  }

  return (
    <Wrapper>
      <DesktopWrapper>
        <MediumUp>
          <Tooltip
            placement={TooltipPlacement.TOP}
            title={`${tooltipLabel}: ${deliveryTimeText}`}
            renderOnMouseOver
          >
            <IconWrapper>
              <IconDelivery color="base400" size={20} />
            </IconWrapper>
          </Tooltip>
        </MediumUp>
      </DesktopWrapper>

      <CaptionText emphasis={FontEmphasis.MEDIUM}>
        {deliveryTimeText}
      </CaptionText>
    </Wrapper>
  );
};

const DesktopWrapper = styled.div`
  ${media.smallOnly`
    display: none;
  `}
`;
